import { z } from 'zod';
const headerMatch = /^#+(.*)$/;
const subHeaderMatch = /^##+(.*)$/;
function stripMentionSyntax(text) {
    return text
        .replace(/\[@([^\]]+)\]\([0-9a-f-]{36}\)/g, (_, label) => label)
        .replace(/\[&([^\]|]+)(?:\|[^\]]+)?\]\([0-9a-f-]{36}\)/g, (_, label) => label)
        .replace(/&nbsp;/g, ' ');
}
function getTitleMarkdown(text) {
    const lines = text.split('\n');
    const noEmptyLines = lines.filter(line => line.length > 0);
    if (noEmptyLines.length === 0) {
        return text;
    }
    const firstLine = noEmptyLines[0];
    const matchHeader = firstLine.match(headerMatch);
    if (matchHeader !== null) {
        const title = matchHeader && matchHeader[1];
        return title.trim();
    }
    const matchSubHeader = firstLine.match(subHeaderMatch);
    if (matchSubHeader !== null) {
        const title = matchSubHeader && matchSubHeader[1];
        return title.trim();
    }
    return text;
}
export const getTitleAndAdditionalText = (note) => {
    const content = stripMentionSyntax(note.content);
    const firstLineBreakIndex = content.indexOf('\n');
    if (firstLineBreakIndex === -1) {
        if (content.length < 100) {
            return {
                title: getTitleMarkdown(content),
                additionalText: '',
            };
        }
        return {
            title: getTitleMarkdown(content.slice(0, 100)),
            additionalText: content.slice(100),
        };
    }
    return {
        title: getTitleMarkdown(content.slice(0, firstLineBreakIndex)),
        additionalText: content.slice(firstLineBreakIndex),
    };
};
/** TODO : improve to show :
 * - Il y a 3 minutes (desk)
 * - 20:30
 * - 22/01/23
 * */
export const getDate = (note) => {
    return note.updated_at.toLocaleDateString();
};
export const notesSchema = z
    .object({
    content: z.string(),
    updated_at: z.coerce.date(),
    id: z.string(),
    exported_count: z.number(),
})
    .array();
export const parseNote = (value) => {
    if (!value) {
        return null;
    }
    const parsing = notesSchema.safeParse(JSON.parse(value));
    if (parsing.success) {
        return parsing.data;
    }
    return null;
};
//# sourceMappingURL=note.utils.js.map